import { PublicClientApplication } from '@azure/msal-browser';

import { msalConfig } from './msalConfig.js';

let _instance: PublicClientApplication | null = null;

export function getMainPca(): PublicClientApplication {
  _instance ??= new PublicClientApplication(msalConfig);
  return _instance;
}
